import { StructuredBriefFragment } from '../BriefForm';

export function isBifrostBrief(brief: StructuredBriefFragment) {
    return brief.request == null && brief.fulfilmentStrategy === 'FULFILMENT_STRATEGY_COMMUNITY';
}
